/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `AlertType*`'s.
 */
export type AlertType =
  | AlertTypeHelp
  | AlertTypeInfo
  | AlertTypeWarning
  | AlertTypeReport
  | AlertTypeAssistant
  | AlertTypeCustom;

/**
 * The Alert help type.
 */
export type AlertTypeHelp = typeof ALERT_TYPE_HELP;

/**
 * The Alert info type.
 */
export type AlertTypeInfo = typeof ALERT_TYPE_INFO;

/**
 * The Alert warning type.
 */
export type AlertTypeWarning = typeof ALERT_TYPE_WARNING;

/**
 * The Alert report type.
 */
export type AlertTypeReport = typeof ALERT_TYPE_REPORT;

/**
 * The Alert assistant type.
 */
export type AlertTypeAssistant = typeof ALERT_TYPE_ASSISTANT;

/**
 * The Alert custom type.
 */
export type AlertTypeCustom = typeof ALERT_TYPE_CUSTOM;

/**
 * The Alert help constant.
 */
export const ALERT_TYPE_HELP = `help`;

/**
 * The Alert info constant.
 */
export const ALERT_TYPE_INFO = `info`;

/**
 * The Alert warning constant.
 */
export const ALERT_TYPE_WARNING = `warning`;

/**
 * The Alert report constant.
 */
export const ALERT_TYPE_REPORT = `report`;

/**
 * The Alert assistant constant.
 */
export const ALERT_TYPE_ASSISTANT = `assistant`;

/**
 * The Alert custom constant.
 */
export const ALERT_TYPE_CUSTOM = `custom`;
